module.exports = __webpack_public_path__ + "static/img/banner.b54d1d0e.png";